export default "__VITE_ASSET__a91aqzQQ__"